import React, { Component } from "react";
import { css } from 'emotion';

import { listUnstyled, navItem, selectedNavLink, selectedNavItem, navLink } from './styles/my-account-menu';

const MenuNavLink = ({ menuLinks }) => (
    <ul className={css`${listUnstyled}`}>
        {menuLinks.map((menuLink, index) => (
            <li className={css`${location.href.match(menuLink.address) === null ? navItem : selectedNavItem}`} key={index}>
                <i className={menuLink.icon}></i>
                <a
                    href={menuLink.address}
                    title={menuLink.title}
                    className={css`${ location.href.match(menuLink.address) === null ? navLink : selectedNavLink }`}>
                    {menuLink.title}
                </a>
            </li>
        ))}
    </ul>
)

export default MenuNavLink;